import { useState } from 'react'
import { useUsersAPI } from 'src/API/central.usersAPI'
import { MultiselectStandard } from 'src/components/standard.multiselect'
import { TablePlater } from 'src/components/standard.table'
import { TypographyLead, TypographySmall, TypographyStandardP1, TypographyStandardTitleH2 } from 'src/components/typography'
import { getRandomHexColor, stringToColor } from 'src/lib/utils'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from 'src/shadcn/ui/accordion'
import { Pagination, PaginationKeys } from 'src/types/pagination'
import { ProjectComponent } from './component.projectCard'
import { useOrganizationsAPI } from 'src/API/central.organizationAPI'
import { SelectStandard } from 'src/components/standard.select'
// import { ImportExcelModal } from './component.importExcelModal'






export function Contributors() {


    const { listOrganizations } = useOrganizationsAPI()

    const {
        listUsers
    } = useUsersAPI()
    const organizations = listOrganizations()
    const [filters, setFilters] = useState<{
        organizationIds?: string[],
        workItems?: 'completed' | 'inProgress' | 'all',
        sortBy?: 'uncompletedFirst' | 'completedFirst' | 'sortByName'
    }>({
        organizationIds: organizations.map(organization => organization.accountId),
        workItems: 'all',
        sortBy: 'completedFirst'
    })
    const users = listUsers({
        filters: {
            workItems: filters.workItems === 'all' ? undefined : filters.workItems,
            organizationIds: filters.organizationIds,

        },
        sortBy: filters.sortBy
    });





    return (
        <div className=' grow  flex flex-col overflow-auto'>

            <TablePlater className=' flex flex-col gap-2'>
                {/* Buttons section */}
                <div className=' flex justify-start w-full gap-4 max-w-[300px] '>
                    <MultiselectStandard
                        title='Organization'
                        name='organization'

                        onValueChange={(e) => {
                            setFilters({
                                ...filters,
                                organizationIds: e.target.value
                            })
                        }}
                        options={[
                            ...organizations.map(organization => ({
                                label: organization.accountName,
                                value: organization.accountId
                            }))
                        ]}
                        placeholder=''
                        value={filters.organizationIds}
                        maxHeight={100}
                    />
                    <SelectStandard
                        title='Status'
                        name='status'
                        onChange={(e) => {
                            setFilters({
                                ...filters,
                                workItems: e.target.value as 'completed' | 'inProgress'
                            })
                        }}
                        options={[
                            {
                                label: 'All',
                                value: 'all',
                            },
                            {
                                value: 'inProgress',
                                label: 'In Progress'
                            },
                            {
                                value: 'completed',
                                label: 'Completed'
                            },
                            
                        ]}
                        value={filters.workItems}
                    />
                    <SelectStandard
                        title='Sort By'
                        name='status'
                        onChange={(e) => {
                            setFilters({
                                ...filters,
                                sortBy: e.target.value as any
                            })
                        }}
                        options={[

                            {
                                value: 'completedFirst',
                                label: 'completed first'
                            },
                            {
                                value: 'uncompletedFirst',
                                label: 'uncompleted first'
                            },
                            {
                                value: 'sortByName',
                                label: 'sort by name'
                            }
                        ]}
                        value={filters.sortBy}
                    />
                </div>
                {
                    users.map(user => {
                        return (
                            (
                                <Accordion key={user.user.originId} type="single" collapsible className="w-full">
                                    <AccordionItem value={'item-1'} >
                                        <AccordionTrigger  >
                                            <div className='grid grid-cols-1  w-full md:grid-cols-5 gap-2 gap-y-4'>
                                                <div className='w-full flex items-center gap-2 md:col-span-3 '>
                                                    <div
                                                        style={{
                                                            background: stringToColor(user.user.mailAddress)
                                                        }}
                                                        className="avatar min-h-12 min-w-12 max-h-12 max-w-12 flex items-center justify-center border rounded-full text-white ">
                                                        {user.user.displayName.charAt(0).toUpperCase()}
                                                    </div>
                                                    <div className=' flex flex-col text-start justify-center '>
                                                        <TypographyLead>{user.user.displayName}</TypographyLead>
                                                        <TypographyStandardP1 >{user.user.mailAddress}</TypographyStandardP1>
                                                    </div>
                                                </div>
                                                <div className=' flex col-span-1 md:col-span-2'>
                                                    <div className=' flex flex-col w-full place-items-end'>
                                                        <div className='flex'>
                                                            <TypographyStandardTitleH2>Projects: </TypographyStandardTitleH2>
                                                            <TypographyStandardP1>{user.projects.length}</TypographyStandardP1>
                                                        </div>
                                                        <div className='flex'>
                                                            <TypographyStandardTitleH2>Total Work Item: </TypographyStandardTitleH2>
                                                            <TypographyStandardP1>{user.totalWorkItem}</TypographyStandardP1>
                                                        </div>
                                                        <div className='flex'>
                                                            <TypographyStandardTitleH2>Completed Work Item: </TypographyStandardTitleH2>
                                                            <TypographyStandardP1>{user.completedWorkItem}</TypographyStandardP1>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </AccordionTrigger>
                                        <AccordionContent>
                                            <div className=' flex flex-col gap-1'>
                                                {user.projects.map(
                                                    project => {
                                                        return (
                                                            <ProjectComponent
                                                                TotalWorkItem={project.userTotalWorkItems}
                                                                completedWorkItem={project.userCompletedWorkItems}
                                                                key={project.id}
                                                                projectName={project.name}
                                                            />
                                                        )
                                                    }
                                                )}
                                            </div>
                                        </AccordionContent>
                                    </AccordionItem>
                                </Accordion>
                            )
                        )
                    })
                }


            </TablePlater>
        </div>
    )

}



